/**
 * This is the main implementation of the navigation component, only
 * missing the bits that require MooTools for implementation (those
 * are implemented in `./navigation` and passed into this component as
 * props.
 */
import { _js } from '@ifixit/localize';
import { Tabs, TabsList, TabsTrigger } from '@ifixit/ui/components/tabs';
import { FaIcon } from '@ifixit/ui/components/icon';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

export function Navigation({ links, heading, pageTitle, onIfixit, isLoggedIn }: any) {
   const visibleTabs = links.tabLinks.filter((tab: any) => tab.showTab);
   const headingText = heading ?? pageTitle;

   function getActiveTabIndex() {
      let index = 0;
      while (index < visibleTabs.length) {
         const tab = visibleTabs[index];
         if (tab.label === pageTitle) {
            break;
         }
         index++;
      }
      return index;
   }

   const activeTabIndex = getActiveTabIndex();
   const currentTabData = visibleTabs[activeTabIndex];
   const activeValue = visibleTabs[activeTabIndex]?.label ?? '';

   return (
      <div id="communityNav" className="mt-6">
         <Tabs value={activeValue}>
            <TabsList className="w-full gap-0 pb-0">
               {visibleTabs.map((tab: any) => (
                  <TabsTrigger
                     key={tab.label}
                     asChild
                     value={tab.label}
                     className="relative min-w-[120px] flex-1 shrink-0 rounded-none border-b-2 border-gray-200 px-5 py-2 text-sm font-semibold no-underline text-gray-500 transition-colors hover:border-gray-400 hover:no-underline hover:text-gray-600 data-[state=active]:border-brand-500 data-[state=active]:bg-transparent data-[state=active]:text-brand-500"
                  >
                     <a href={tab.url}>{tab.label}</a>
                  </TabsTrigger>
               ))}
            </TabsList>
         </Tabs>
         <header className="mt-6 flex flex-wrap items-center justify-center md:justify-between">
            <h1 className="mb-1.5 w-full text-[30px] font-medium text-gray-800 md:mb-0 md:w-auto">
               {headingText}
            </h1>
            <div className="hidden flex-auto flex-wrap justify-end gap-2 md:flex md:gap-4">
               {onIfixit && (
                  <a
                     href={currentTabData?.help}
                     className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                     onClick={() => {
                        trackAnalyticsCustomEvent({
                           eventCategory: pageTitle,
                           eventAction: `${pageTitle} - Btn "How this Works"`,
                           eventName: currentTabData?.help,
                        });
                     }}
                  >
                     {_js('How this Works')}
                     <FaIcon name="circle-info" className="size-4" />
                  </a>
               )}
               {!isLoggedIn && (
                  <a
                     href="/Join"
                     className="buttonLink inline-block"
                     onClick={() => {
                        trackAnalyticsCustomEvent({
                           eventCategory: pageTitle,
                           eventAction: `${pageTitle} - Btn - Join`,
                        });
                     }}
                  >
                     {_js('Join')}
                  </a>
               )}
            </div>
         </header>
      </div>
   );
}
